import React from "react";
import HomeHero from "../components/home/HomeHero";
import HomeAbout from "../components/home/HomeAbout";
import AboutLegacy from "../components/about/AboutLegacy";
import HomeSmallBeginning from "../components/home/HomeSmallBeginning";

import AboutVision from "../components/about/AboutVision";
import AboutTeam from "../components/about/AboutTeam";
import HomeNominate from "../components/home/HomeNominate";

//Awardee

import HomeSectionAnterdhvani from "../components/home/HomeAnterdhvani";

import HomeParticipation from "../components/home/HomeParticipation";
import HomeMissionHimmat from "../components/home/HomeMissionHimmat";
import HomeSponser from "../components/home/HomeSponser";
import AboutTestimonials from "../components/about/AboutTestimonials";
import HomeRastraPrerna from "../components/home/HomeRastraPrerna";
import HomeBlogs from "../components/home/HomeBlogs";
import HomeTrademark from "../components/home/HomeTrademark";

import AwardeeSection from "../components/awards/AwardeeSection";

const sectionToneClass = {
  white: "[&_section]:!bg-white",
  light: "[&_section]:!bg-bg-light",
};

const elevatedCardClass = {
  white: "[&_article]:!bg-bg-light",
  light: "[&_article]:!bg-white",
};

const HomeSection = ({ tone, elevated = false, children }) => (
  <div
    className={`${sectionToneClass[tone]}${elevated ? ` ${elevatedCardClass[tone]}` : ""}`}
  >
    {children}
  </div>
);

const HomePage = () => {
  return (
    <>
      <HomeHero />
      <HomeSection tone="white">
        <HomeAbout />
      </HomeSection>
      <HomeSection tone="light">
        <AboutLegacy />
      </HomeSection>
      <HomeSection tone="white">
        <HomeSmallBeginning />
      </HomeSection>

      <HomeSection tone="light">
        <AwardeeSection />
      </HomeSection>
      <HomeSection tone="white">
        <AboutVision />
      </HomeSection>
      <HomeSection tone="light">
        <AboutTestimonials />
      </HomeSection>
      <HomeSection tone="white">
        <HomeRastraPrerna />
      </HomeSection>
      <HomeSection tone="light">
        <HomeMissionHimmat />
      </HomeSection>
      <HomeSection tone="white">
        <HomeSectionAnterdhvani />
      </HomeSection>
      <HomeSection tone="light">
        <HomeParticipation />
      </HomeSection>
      <HomeSection tone="white">
        <HomeSponser />
      </HomeSection>
      <HomeSection tone="light">
        <HomeBlogs />
      </HomeSection>
      <HomeSection tone="white">
        <HomeTrademark />
      </HomeSection>
      {/* <HomeSection tone="light">
        <HomeRecentMissionGallery />
      </HomeSection> */}
      <HomeSection tone="light">
        <HomeNominate />
      </HomeSection>
      <HomeSection tone="white">
        <AboutTeam />
      </HomeSection>
    </>
  );
};

export default HomePage;
